import Phaser from 'phaser';
import { audio } from './AudioSynth';
import { RuntimeAssetsScene } from '../scenes/RuntimeAssetsScene';

/** Consistent short confirmation + fade for screen-to-screen navigation. */
export function navigateTo(scene: Phaser.Scene, key: string, data?: object): void {
  audio.click();
  const transitionStarted = performance.now();
  // A click must feel acknowledged immediately, even when the shared tactical
  // pack is still finishing in the background.
  scene.cameras.main.fadeOut(160, 0, 0, 0);
  void (async () => {
    // Keep the landing menu responsive, but guarantee that every scene which
    // uses authored tactical textures enters only after the shared pack is in
    // Phaser's global caches.
    if (key !== 'Menu') await RuntimeAssetsScene.ensureStarted(scene);
    // Use the browser clock for the hand-off. A paused/throttled Phaser scene
    // clock must not strand the player on a fading screen.
    const remainingFade = Math.max(0, 160 - (performance.now() - transitionStarted));
    globalThis.setTimeout(() => scene.scene.start(key, data), remainingFade);
  })();
}
